import React, { useEffect, useState, useRef } from 'react';
import Input from '../components/Input';
import Button from '../components/Button';
import Text from '../components/Text';
import Avatar from '../components/Avatar';
import { Link, useNavigate } from "react-router-dom";
import { getCookie, setCookie, killCoockie } from '../assets/js/helper'
import axios from "axios";

function Home(props) {

    const [avatar, setAvatar] = useState(null);
    const [pseudo, setPseudo] = useState(null);
    const [score, setScore] = useState(null);
    const [email, setEmail] = useState(null);
    const [lettre, setLettre] = useState(null);
     // Recup des infos des cookies
     const wPlayer = JSON.parse(getCookie('w-player'));
     console.log('player', wPlayer.player);
     console.log('avatar', wPlayer.player.avatar);
     console.log('pseudo', wPlayer.player.pseudo); 
     console.log('score', wPlayer.player.score); 
     console.log('email', wPlayer.player.email); 

     useEffect(() => {
        setAvatar(wPlayer.player.avatar); 
        setEmail(wPlayer.player.email); 
        setPseudo(wPlayer.player.pseudo);
        setScore(wPlayer.player.score+' pts');
    },[]);    
 
    const [allParties, setallParties] = useState([]);

    const getAllParties = () => (
        axios.get('http://127.0.0.1:5000/apiRouter/all_parties')
            .then(res => {
                console.log(res.data)
                setallParties(...allParties, res.data.parties)
            })
            .catch(err => console.error(`Error: ${err}`))
    )

    useEffect(() => {
        getAllParties()
        return () => {
            
        };
    }, [])

    return (
        <div className="w-home row w-fullscreen">
            <div className='col-lg-3 bg-blue w-half-left'>
                <Avatar
                    type="w-avatar-info"
                    nom={pseudo}
                    mail={email}
                    worder={score}
                    src={avatar}
                    classes="w-avatar-info"
                />
                <Link to="/home">
                    <Button text="Accueil" classes="w-btn w-btn-blue" />
                </Link> 
                <Link to="/partielettre">
                    <Button text="Nouvelle partie" classes="w-btn-white" />
                </Link>
                <Link to="/scores">
                    <Button text="Voir les scores" classes="w-btn-white" />
                </Link>
                <Link to="/worders">
                    <Button text="Les WOrders (50)" classes="w-btn-white" />
                </Link>
                <Link to="/">
                    <Button text="Quitter" classes="w-text w-btn-gray" />
                </Link>
                <Link to="/aide">
                    <Text text="Besoin d'aide ?" classes="w-text-white-lg" />
                </Link>
            </div>
            <div className='col-lg-9 w-half-right'>
                <img className="w-img-lg" src="/img/categories/wordin_full.png" alt="home" />
                <Text text="Toutes les parties" classes="w-text-blue-l" />
                <br />
                <table class="table w-table">
                    <thead>
                        <tr>
                            <th scope="col">
                                <Text text="N°" classes="w-text-blue-m" />
                            </th>
                            <th scope="col">
                                <Text text="Identifiant°" classes="w-text-blue-m" />
                            </th>
                            <th scope="col">
                                <Text text="Lettre" classes="w-text-blue-m" />
                            </th>
                            <th scope="col">
                                <Text text="Score/Action" classes="w-text-blue-m" />
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        { allParties && allParties.map((partie) => {
                            let { id, lettre, numero, statuc} = partie
                           return <tr className='w-row-blue'>
                                <th scope="row">
                                    <Text text={id} classes="w-text-black-simple" />
                                </th>
                                <th scope="row">
                                    <Text text={numero} classes="w-text-black-simple" />
                                </th>
                                <th scope="row">
                                    <Text text={lettre} classes="w-text-black-simple" />
                                </th>
                                <th scope="row">
                                   {statuc === "encours" ? <Link to="/partielettre">
                                        <Button text="Rejoindre" classes="w-btn-blue-s" />
                                    </Link> : null} 
                                   {statuc === "terminé" ? "Terminé" : null} 
                                </th>
                            </tr>
                        })}
                    </tbody>
                </table>
            </div>
        </div>
    );
}

export default Home;